import { TaxonomyElement } from "./TaxonomyElement";

export type SupplierProductMapping = {
    supplierId: number,
    supplierProductId: string,
    supplierProductName: string,
    unit: string,
    boxingType: string,
    boxingWeight: number,
    boxingWeightUnit: string,
    boxingNoOfItems: number,

    catalogueProductId: string,
    catalogueReference: TaxonomyElement | null,
    attributes: { [name: string]: string },

    askingPrice: number,
    minimalPriceModifier: number,
    currency: string,
    mappingStatus: ProductMappingStatus

    _isMapped: boolean,
    _isDirty: boolean,
    _isPriceInvalid?: boolean
}

export enum ProductMappingStatus {
    CONFIRMED = 'CONFIRMED',
    PROPOSED = 'PROPOSED',
    NEW = 'NEW'
}

export enum BoxingType {
    PACKAGE = 'https://qmo.com/core#perPackage',
    LOOSE = 'https://qmo.com/core#perKilo',
}